<template>
    <div>
      <Head title="Dispatch Receipts" />
      <h1 class="mb-8 text-3xl font-bold">
            <span>Dispatch</span>
            <span class="font-medium">/</span>Receipts
      </h1>
      <div class="flex items-center mb-6">
      <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
      <hr />
      <ul
        id="tabs-tabFill"
        class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
        role="tablist"
      >
        <li class="nav-item flex-auto text-center" role="presentation">
          <a
            id="tabs-home-tabFill"
            href="#tabs-homeFill"
            class="
            nav-link
            w-full
            block
            font-medium
            text-xs
            leading-tight
            uppercase
            border-x-0 border-t-0 border-b-2 border-transparent
            px-6
            py-3
            my-2
            hover:border-transparent hover:bg-gray-100
            focus:border-transparent
            active" 
            data-bs-toggle="pill" 
            data-bs-target="#tabs-homeFill" 
            role="tab"
            aria-controls="tabs-homeFill"
            aria-selected="true"
          >
            Scans
          </a>
        </li>
        <li
          class="nav-item flex-auto text-center"
          role="presentation"
        >
          <a
            id="tabs-summary-tabFill"
            href="#tabs-summaryFill"
            class="
            nav-link
            w-full
            block
            font-medium
            text-xs
            leading-tight
            uppercase
            border-x-0 border-t-0 border-b-2 border-transparent
            px-6
            py-3
            my-2
            hover:border-transparent hover:bg-gray-100
            focus:border-transparent"
            data-bs-toggle="pill"
            data-bs-target="#tabs-summaryFill"
            role="tab"
            aria-controls="tabs-summaryFill"
            aria-selected="false"
          >
            Summaries
          </a>
        </li>
      </ul>
      <div id="tabs-tabContentFill" class="tab-content">
        <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
          <div class="flex items-center justify-between mb-6">
            <a
              v-if="today_receipts.data.length > 0"
              :href="`/dispatches/receipts/download/sum${urlScans()}`"
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              download
              target="__blank"
            >
              <span>Download</span>
            </a>
          </div>
          <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-3 pt-3 px-3">Date</th>
                <th class="pb-3 pt-3 px-3">Item UID</th>
                <th class="pb-3 pt-3 px-3">Part Number</th>
                <th class="pb-3 pt-3 px-3">Description</th>
                <th class="pb-3 pt-3 px-3">Quantity</th>
                <th class="pb-3 pt-3 px-3">Location</th>
                <th class="pb-3 pt-3 px-3">UoM</th>
                <th class="pb-3 pt-3 px-3">Picklist</th>
                <th class="pb-3 pt-3 px-3">Source</th>
                <th class="pb-3 pt-3 px-3" colspan="2">Received By</th>
              </tr>
              <tr v-for="item in today_receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                    {{ item.date }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.item_name }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.part_no }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.description }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.quantity }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.location }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.unit_of_measure }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.pick_list_no }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.source }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-3 py-2" tabindex="-1">
                    {{ item.user }}
                  </Link>
                </td>
                <td class="w-px border-t">
                  <Link class="flex items-center px-3" tabindex="-1">
                    <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                  </Link>
                </td>
              </tr>
              <tr v-if="today_receipts.data.length === 0">
                <td class="px-2 py-2 border-t" colspan="11">No data found</td>
              </tr>
            </table>
          </div>
          <pagination class="mt-6" :links="today_receipts.links" />
        </div>
        <div id="tabs-summaryFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
          <div class="flex items-center justify-between mb-6">
            <a
              v-if="summaries.data.length > 0"
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              :href="`/dispatches/receipts/summaries/download/sum${urlScans()}`"
              download
              target="__blank"
            >
              <span>Download</span>
            </a>
          </div>
          <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-2 pt-2 px-3">Part Number</th>
                <th class="pb-2 pt-2 px-3">Part Description</th>
                <th class="pb-2 pt-2 px-3">Quantity Ordered</th>
                <th class="pb-2 pt-2 px-3">Quantity Picked</th>
                <th class="pb-2 pt-2 px-3">Quantity Packed</th>
                <th class="pb-2 pt-2 px-3">UoM</th>
              </tr>
              <tr
                v-for="inventory in summaries.data"
                :key="inventory.id"
                class="hover:bg-orange-100 focus-within:bg-gray-100"
              >
                <td class="border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.sku_name }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.description }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.quantity_ordered }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.quantity_picked }}
                  </span>
                </td>
                <td class="border-t">
                  <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                    {{ inventory.quantity_packed }}
                  </span>
                </td>
                <td class="w-px border-t">
                  <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                    {{ inventory.unit_of_measure }}
                  </span>
                </td>
              </tr>
              <tr v-if="summaries.data.length === 0">
                <td class="px-6 py-4 border-t" colspan="8">No data found</td>
              </tr>
            </table>
          </div>
          <pagination class="mt-6" :links="summaries.links" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import SearchFilter from '@/Shared/SearchFilter'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import DateRange from '@/Shared/DateRange'
  import LoadingButton from '@/Shared/LoadingButton'
  import Pagination from '@/Shared/Pagination'
  
  export default {
    components: {
      Head,
      Icon,
      Link,
      SearchFilter,
      DateRange,
      LoadingButton,
      Pagination,
    },
    layout: Layout,
    props: {
      filters: Object,
      today_receipts: Object,
      summaries: Object,
    },
    data() {
      return {
        search: {
          dateValue: this.filters.dateValue,
        },
      }
    },
    computed: {
      role() {
        return this.$inertia.page.props.auth.user.role
      },
    },
    watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatches/receipts', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
    methods: {
      reset() {
        this.search = mapValues(this.search, () => null)
      },
      urlScans() {
        let query = ''
        if (this.search.dateValue) {
          query += `dateValue=${this.search.dateValue}`
        }
        if (query) {
          query = `?${query}`
        }
        return query
      },
    }
  }
  </script>
  